<script setup lang="ts">
const { t } = useI18n()

useHead({
  titleTemplate: 'DMCA Copyright Policy | SMSBAT',
  meta: [
    { name: "description", content: 'DMCA Copyright Policy for the SMSBAT Omnichannel Platform.' },
    { property: "og:title", content: 'DMCA Copyright Policy | SMSBAT' },
    { property: "og:description", content: 'DMCA Copyright Policy for the SMSBAT Omnichannel Platform.' },
    { property: "og:type", content: "website" },
    { name: "twitter:card", content: "summary_large_image" }
  ]
})
</script>

<template>
  <div class="m-5">
    <div class="text-2xl font-bold mb-5 text-2xl">DMCA Copyright Policy</div>
    <div class="text" data-v-6dfe8f46="">
      <p data-v-6dfe8f46="">
        SMSBAT, LLC. ("<strong data-v-6dfe8f46="">SMSBAT</strong>")
        respects the intellectual property rights of others and requests the
        users of its services to do the same. If you believe that certain
        content, which appears on SMSBAT cloud-based image management
        solution (the "<strong data-v-6dfe8f46="">Service</strong>"), infringes
        upon copyrights that you own or represent, you may send SMSBAT's
        designated copyright agent ("<strong data-v-6dfe8f46="">Copyright Agent</strong>") a written notification,
        stating the location of the copyrighted work
        claimed to be infringed, in accordance with the provisions of the
        Digital Millennium Copyright Act ("<strong data-v-6dfe8f46="">DMCA</strong>").
      </p>
      <p data-v-6dfe8f46="">
        Upon your notification, SMSBAT may remove or disable access to any
        such content.
      </p>
      <p data-v-6dfe8f46="">
        To be effective, your notification of claimed infringement must be a
        written communication provided to the Copyright Agent that includes
        substantially the following:
      </p>
      <ol data-v-6dfe8f46="">
        <li data-v-6dfe8f46="">
          A physical or electronic signature of a person authorized to act on
          behalf of the owner of an exclusive right that is allegedly infringed;
        </li>
        <li data-v-6dfe8f46="">
          Identification of the copyrighted work claimed to be infringed via
          using the Service, or if multiple copyrighted works are covered by a
          single notification, a representative list of such works;
        </li>
        <li data-v-6dfe8f46="">
          Identification of the material that is claimed to infringe or to be
          the subject of infringing activity and that access to which is to be
          disabled, and information reasonably sufficient to permit SMSBAT
          to locate the material;
        </li>
        <li data-v-6dfe8f46="">
          Information reasonably sufficient to permit SMSBAT to contact you,
          such as an address, telephone number, and, if available, an electronic
          mail address at which you may be contacted;
        </li>
        <li data-v-6dfe8f46="">
          A statement that you have a good faith belief that the use of the
          material in the manner complained of is not authorized by the
          copyright owner, its agent, or the law;
        </li>
        <li data-v-6dfe8f46="">
          A statement that the information in the notification is accurate, and
          under penalty of perjury, that you are authorized to act on behalf of
          the owner of an exclusive right that is allegedly infringed.
        </li>
      </ol>
      <p data-v-6dfe8f46="">
        Following receipt of your communication, SMSBAT may ask you to
        provide further or supplemental information, prior to removing any
        content which was displayed on the Service, as SMSBAT deems
        necessary to comply with the provisions of the DMCA. SMSBAT may also
        provide the registered user who uploaded the allegedly infringing
        content with your contact details, in order for that person to be able
        to contact you directly and communicate with you regarding your
        notification.
      </p>
      <h2 class="text-xl font-bold my-5" data-v-6dfe8f46="">
        Submission of the Notice
      </h2>
      <h2 class="text-xl font-bold my-5" data-v-6dfe8f46="">
        Copyright Agent Details
      </h2>
      <p data-v-6dfe8f46="">
        Please submit your notice to our Copyright Agent at:
        <a href="mailto:copyright@smsbat.com" data-v-6dfe8f46="">copyright@smsbat.com</a>
        or mail it to the following address:
      </p>
      <p data-v-6dfe8f46="">
        SMSBAT, LLC. <br data-v-6dfe8f46="" />
        Att: Copyright Agent <br data-v-6dfe8f46="" />
        08160, Ukraine, Fastiv district, Kyiv region, village of Gatne, street Hrushevskoho M., building, 18, apartment,
        42
      </p>
      <p data-v-6dfe8f46="">
        Please note that the Copyright Agent receives DMCA notifications only.
        Any other matters, such as comments, requests and other messages should
        be referred to:
        <a href="https://smsbat.com.ua/contact.html" data-v-6dfe8f46="">https://smsbat.com.ua/contact.html</a>.
      </p>
      <h2 class="text-xl font-bold my-5" data-v-6dfe8f46="">Counter notification</h2>
      <p data-v-6dfe8f46="">
        As the registered user who uploaded the allegedly infringing content,
        you may submit a counter notification to the Copyright Agent. To be
        effective, your counter notification must be a written communication
        provided to the Copyright Agent that includes substantially the
        following:
      </p>
      <ol data-v-6dfe8f46="">
        <li data-v-6dfe8f46="">Your physical or electronic signature;</li>
        <li data-v-6dfe8f46="">
          Identification of the material to which access has been disabled and
          the location at which the material appeared before access to it was
          disabled.
        </li>
        <li data-v-6dfe8f46="">
          A statement under penalty of perjury that you have a good faith belief
          that the material was disabled as a result of mistake or
          misidentification of the material to be disabled;
        </li>
        <li data-v-6dfe8f46="">
          Your name, address, and telephone number, and a statement that you
          consent to the jurisdiction of the Federal District Court for the
          judicial district in which your address is located, or if your address
          is outside of the United States, for any judicial district in which
          you may be found, and that you will accept service of process from the
          person who provided notification or an agent of such person.
        </li>
      </ol>
      <p data-v-6dfe8f46="">
        After receipt of a counter notification, SMSBAT will promptly
        provide the person who submitted the claimed copyright infringement
        notification with a copy of the counter notification, and will inform
        that person that SMSBAT will replace the removed material, or cease
        disabling access to that material 10 business days.
      </p>
      <p data-v-6dfe8f46="">
        SMSBAT will then replace the removed the material and cease
        disabling access to it between 10 to 14 business days following receipt
        of the counter notification, unless the Copyright Agent first receives
        notice from the person who notified SMSBAT of the claimed copyright
        infringement that such person has filed an action seeking a court order
        to restrain the registered user from engaging in infringing activity
        relating to the material on SMSBAT's system or network.
      </p>
      <h2 class="text-xl font-bold my-5" data-v-6dfe8f46="">Repeat infringements</h2>
      <p data-v-6dfe8f46="">
        SMSBAT may deny or cancel any individual use of the Service, or
        terminate your user account, if SMSBAT determines in its sole
        discretion that you are a repeat infringer. A repeat infringer is a user
        who has been notified of infringing activity more than once or a user
        that his or her uploaded material was removed from the Service more than
        once. SMSBAT may decide, at its sole discretion that a sufficient
        reason exists for the immediate termination of your account for any
        reason, at any time. In these case SMSBAT may terminate your account
        immediately. SMSBAT may notify you that it canceled your account by
        sending a message to the e-mail address that you provided during the
        registration process. Such notification will come into effect
        immediately.
      </p>
      <h2 class="text-xl font-bold my-5" data-v-6dfe8f46="">Misrepresentations</h2>
      <p data-v-6dfe8f46="">
        Under the provisions of the DMCA, any person who knowingly materially
        misrepresents: (1) that material is infringing, or (2) that material was
        removed or disabled by mistake or misidentification, will be liable for
        any damages, including costs and attorneys’ fees, that SMSBAT may
        incur, if it is injured by such misrepresentation, as the result of its
        reliance upon such misrepresentation in removing or disabling access to
        the material claimed to be infringing.
      </p>
      <p class="my-5" data-v-6dfe8f46="">Last updated: May 1, 2023</p>
    </div>
  </div>
</template>
